import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import marked from "marked"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image"

const SecondPage = ({ data }) => {
  // console.log(data)
  const ggimage = getImage(
    data.page.mainImage !== null
      ? data.page?.mainImage?.asset?.gatsbyImageData
      : null
  )
  const convertggimage = convertToBgImage(ggimage)
  return (
    <Layout>
      <Seo
        title={data && data.page.metaTitle}
        description={data && data.page.metaDescription}
      />
      <BackgroundImage Tag="div" {...convertggimage} className="page-headline">
        <div className="bg-blog-tmp-wrap" />
        <div className="container">
          <div className="section-heading text-center">
            <h6 className="font-weight-bold text-uppercase text-white-50 flair">
              {data && data.page.categories[0].title}
            </h6>
            <h1>
              <strong>{data && data.page.title}</strong>
            </h1>
          </div>
        </div>
      </BackgroundImage>
      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-md-10 m-auto">
              <div
                dangerouslySetInnerHTML={{
                  __html: marked(data && data.page.body),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default SecondPage

export const PageTemplate = graphql`
  query PageTemplateQuery($id: String!) {
    page: sanityPage(id: { eq: $id }) {
      id
      title
      body
      slug {
        current
      }
      categories {
        title
      }
      mainImage {
        asset {
          gatsbyImageData(
            placeholder: BLURRED
            layout: CONSTRAINED
            fit: FILL
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      metaTitle
      metaDescription
    }
  }
`
